import React from 'react'
import { FlatList, FlatListProps } from 'react-native'

interface CarouselProps<ItemT> {
  data: ItemT[]
  renderItem: FlatListProps<ItemT>['renderItem']
  flatListRef?: React.RefObject<FlatList<ItemT>>
  scrollEnabled?: boolean
  horizontal?: boolean
  pagingEnabled?: boolean
}

export const Carousel = <ItemT extends { key: string }>({ data, renderItem, flatListRef }: CarouselProps<ItemT>) => {
  return (
    <FlatList
      ref={flatListRef}
      data={data}
      horizontal={true}
      scrollEnabled={false}
      showsHorizontalScrollIndicator={false}
      renderItem={renderItem}
    />
  )
}
